import { Flex, Progress, Tooltip } from 'antd';
import DateTime from 'utils/datetime';

interface MonthProgressProps {
  type: 'past' | 'present' | 'future';
  title: React.ReactNode;
  subtitle: React.ReactNode;
  start?: string;
  end?: string;
}

export const MonthProgress = ({
  start,
  end,
  type,
  title,
  subtitle,
}: MonthProgressProps) => {
  const config = {
    past: '#91CAFF',
    present: '#256AF4',
    future: '#00000073',
  };

  const strokeColor = config?.[type];

  return (
    <Flex vertical gap={4} className="month-status">
      <Tooltip
        align={{ offset: [0, 0] }}
        title={`${DateTime.format(start, 'MMM DD, YYYY')} - ${DateTime.format(end, 'MMM  DD, YYYY')}`}
      >
        <Progress
          className="month-progress"
          type="line"
          percent={type === 'future' ? 0 : 100}
          showInfo={false}
          strokeColor={strokeColor}
        />
      </Tooltip>

      <Flex vertical gap={0}>
        <span className="month-status__label">{title}</span>
        <span
          className="month-status__helpertext"
          style={{ color: strokeColor }}
        >
          {subtitle}
        </span>
      </Flex>
    </Flex>
  );
};

export default MonthProgress;
